import { db } from "@/firebase";

// Admin notifications (bell in the app bar), written by the danger Cloud Functions. Admins only (firestore.rules).
const notificationsRef = db.collection("adminNotifications");

function createdAtMillis(notification) {
  const value = notification.created_at;
  return value && typeof value.toMillis === "function" ? value.toMillis() : 0;
}

export const AdminNotificationsService = {
  actions: {
    // Calls onChange with the unread notifications, newest first, on every change. Returns the unsubscribe function.
    watchUnread(onChange, onError) {
      // Sorted here rather than with orderBy, so the query needs no composite index
      return notificationsRef
        .where("read", "==", false)
        .limit(100)
        .onSnapshot((snapshot) => {
          const notifications = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
          onChange(notifications.sort((a, b) => createdAtMillis(b) - createdAtMillis(a)));
        }, onError);
    },
    async markRead(ids) {
      const batch = db.batch();
      ids.forEach((id) => batch.update(notificationsRef.doc(id), { read: true }));
      await batch.commit();
    },
  },
};
